export const toHotelAPILanguage = language =>
  language === 'en-gb' ? 'en-us' : language;
